// @flow

export default () => {
  const nextActiveRow = document.getElementsByClassName('preActiveRow')[0];
  const nextActiveItem = document.getElementsByClassName('preActiveItem')[0];
  const prevActive = {
    activeRow: document.getElementsByClassName('activeRow'),
    activeItem: document.getElementsByClassName('activeItem'),
    lastActive: document.getElementsByClassName('lastActive'),
  };
  Object.keys(prevActive)
    .forEach((listItem : any) => {
      Array.from(prevActive[listItem])
        .forEach((item : any) => {
          item.classList.remove(listItem);
        });
    });
  if (nextActiveRow) {
    nextActiveRow.classList.add('activeRow');
  }
  if (nextActiveItem) {
    nextActiveItem.classList.add('activeItem', 'lastActive');
  }
};
